import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import './NotifyAlert.css';

const NotifyAlert = (title, message) => {
  confirmAlert({
    title,
    message,
    buttons: [
      {
        label: 'OK',
        onClick: () => {},
      },
    ],
  });
};
export default NotifyAlert;
